interface Props {
  onDigit: (digit: string) => void;
  onBackspace: () => void;
}

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '00', '0'];

/**
 * Pavé de saisie. Les chiffres s'accumulent en centimes : « 4550 » donne
 * 45,50 €. Aucune virgule à chercher, et la touche « 00 » expédie les montants
 * ronds — ce qui compte quand on saisit debout, à la caisse.
 */
export function NumericPad({ onDigit, onBackspace }: Props) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {KEYS.map((key) => (
        <button
          key={key}
          type="button"
          onClick={() => onDigit(key)}
          className="rounded-2xl bg-surface py-5 text-2xl font-medium active:bg-line"
        >
          {key}
        </button>
      ))}
      <button
        type="button"
        onClick={onBackspace}
        aria-label="Effacer le dernier chiffre"
        className="rounded-2xl bg-surface py-5 text-2xl active:bg-line"
      >
        ⌫
      </button>
    </div>
  );
}
